import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import { logout } from '../../utils/auth';
import CompanyPlacementDrives from './CompanyPlacementDrives';
import CompanyPostVacancy from './CompanyPostVacancy';
import CompanyMyVacancies from './CompanyMyVacancies';
import CompanyApplications from './CompanyApplications';
import CompanyVacancyDetail from './CompanyVacancyDetail';
import CompanyDashboardHome from './CompanyDashboardHome';
import './CompanyDashboard.css';

function CompanyDashboard() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const menuItems = [
    { path: '', label: 'Dashboard', icon: '📊' },
    { path: 'placement-drives', label: 'Placement Drives', icon: '📋' },
    { path: 'post-vacancy', label: 'Post Vacancy', icon: '➕' },
    { path: 'my-vacancies', label: 'My Vacancies', icon: '💼' },
    { path: 'applications', label: 'Applications', icon: '📄' },
  ];

  const handleLogout = async () => {
    await authService.logout();
    logout();
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className="company-dashboard">
      <div className={`company-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Company Portal</h2>
          <button className="sidebar-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            {isSidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {isSidebarOpen && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            {isSidebarOpen && <span>Logout</span>}
            <span className="logout-icon">🚪</span>
          </button>
        </div>
      </div>
      <div className="company-content">
        <Routes>
          <Route path="placement-drives" element={<CompanyPlacementDrives />} />
          <Route path="post-vacancy" element={<CompanyPostVacancy />} />
          <Route path="my-vacancies" element={<CompanyMyVacancies />} />
          <Route path="vacancy/:id" element={<CompanyVacancyDetail />} />
          <Route path="applications" element={<CompanyApplications />} />
          <Route path="" element={<CompanyDashboardHome />} />
        </Routes>
      </div>
    </div>
  );
}

export default CompanyDashboard;
